
export const formatTime = (hours) => {
if (hours < 0 || hours > 23) {
    throw new Error('Hours must be between 0 and 23.');
}

const period = hours >= 12 ? 'PM' : 'AM';
const formattedHour = hours % 12 === 0 ? 12 : hours % 12;

return `${formattedHour} ${period}`;
};

export const dateSlashesToLongform = (dateStr) => {
    const [month, day, year] = dateStr.split('/').map(Number);
    const date = new Date(year, month - 1, day); // Month is zero-based in JS Dates
  
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
};

export const formatDateToSlashes = (dateStr) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  return `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;
};